export default "__VITE_PUBLIC_ASSET__7310fd5e__"